import { FC, memo, useMemo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer, Panel, Table } from 'ui/components'

import { CompanyDocumentsTitle } from '../CompanyDocumentsTitle'
import { CompanyDocumentsProps } from './CompanyDocumentsProps'
import { columns } from './columns'

export const CompanyDocuments: FC<CompanyDocumentsProps> = memo((props) => {
  const {
    documentsUploading,
    index,
    readonly,
    isLoading,
    onAddFiles,
    onRemoveFile,
    isDocumentDeleting,
    currentCompany
  } = props
  const { name, uploading, id } = documentsUploading

  const mappedAM = useMemo(
    () =>
      uploading.map((el) => ({
        item: el
      })),
    [uploading]
  )

  const fileAddHandler = (document: File[], documentId: number) => {
    onAddFiles(document, documentId, id)
  }

  return (
    <>
      <Layer rounded shadowed>
        <Panel title={<CompanyDocumentsTitle companyName={name} title={`Company #${index + 1}`} />}>
          <Table
            dataQa={TableDataQa.ONBOARDING_FORM_COMPANY_DOCUMENTS_LIST}
            noDataMessage={'No Documents Necessary'}
            columns={columns(readonly, name, fileAddHandler, onRemoveFile, isLoading, isDocumentDeleting)}
            dataSource={mappedAM}
            loading={currentCompany === id}
          />
        </Panel>
      </Layer>
      <div style={{ height: '40px' }} />
    </>
  )
})
